import React, { Component } from "react";
import SandboxMain from "./SandboxMain.js";
import { createStackNavigator } from '@react-navigation/stack';
import { Container, Button, Text, Icon, Footer, FooterTab } from "native-base";
import { Styles, Layouts } from '../../utils';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';


const screensList = [
    {
        name: "SandboxMain",
        scrComp: SandboxMain,
        Title: "Sandbox",
    },
]

export default function SandboxScreenNavigator({ route, navigation }) {
    return(
        <Layouts.GenerateStackRoutes screensList={screensList} route={route} navigation={navigation} />
    )
}
